/**
 * Preferências do escritório neste browser — do POSTO DE TRABALHO, não da conta.
 *
 * Hoje guarda só se a barra de ajuda ("Anda com WASD…") está arrumada. Vive em
 * `localStorage` pela mesma razão do `voicePrefs`: quem já sabe os comandos
 * arruma-a uma vez e não a quer de volta a cada F5, e quem entra pelo telemóvel
 * de outra pessoa merece vê-la na mesma. Não é dado de conta; é de dispositivo.
 *
 * Ler nunca rebenta: `localStorage` bloqueado (modo privado, permissões) ou um
 * valor corrompido devolvem o default em silêncio. Uma preferência não é dado
 * crítico — falhar a lê-la não pode partir o arranque do escritório.
 */

export interface OfficePrefs {
  /** Barra de ajuda do rodapé arrumada (fica só a setinha para a trazer de volta). */
  hintHidden: boolean;
}

const KEY = "gv.office.prefs";

export const DEFAULT_OFFICE_PREFS: OfficePrefs = { hintHidden: false };

export function loadOfficePrefs(): OfficePrefs {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return DEFAULT_OFFICE_PREFS;
    const parsed = JSON.parse(raw) as Partial<OfficePrefs>;
    return { hintHidden: Boolean(parsed.hintHidden) };
  } catch {
    return DEFAULT_OFFICE_PREFS;
  }
}

export function saveOfficePrefs(prefs: OfficePrefs): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(prefs));
  } catch {
    // Sem persistência (modo privado): a escolha vale só esta sessão. Ok.
  }
}
